export default "__VITE_ASSET__CPsM7VwO__"